export default "__VITE_ASSET___SwGqQHn__"